<mat-spinner *ngIf="loading" style="margin:0 auto;"></mat-spinner>

<div *ngIf="!loading">

    <h1 style="margin-top:0; margin-bottom: 1em;">Module - {{moduleObj.label}}</h1>

    <div *ngIf="moduleObj.questionsOrderedIDs.length != 0">

        <div *ngIf="moduleObj.type == ModuleType.TEST" style="margin-bottom: 3em;">

            <h2 fxLayoutAlign="space-between">
                <span>Marks</span>
                <!-- <button mat-flat-button color="primary" (click)="downloadMarks()"><mat-icon>download</mat-icon> Download</button> -->
            </h2>

            <mat-card>

                <mat-table [dataSource]="moduleObj.usersOrdered" matSort (matSortChange)="sortUsers($event)">

                    <ng-container matColumnDef="Name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>User</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.name}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="Mark">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>Mark</mat-header-cell>
                        <mat-cell *matCellDef="let user">
                            {{user.mark}} / {{this.moduleObj.questions.size}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="MarkPercentage">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let user" fxLayoutAlign="end center">
                            {{user.mark / this.moduleObj.questions.size | percent : '1.2-2'}}
                        </mat-cell>
                    </ng-container>

                    <mat-header-row *matHeaderRowDef="['Name', 'Mark', 'MarkPercentage']"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: ['Name', 'Mark', 'MarkPercentage'];"></mat-row>

                </mat-table>

                <p *ngIf="moduleObj.usersOrdered.length == 0" style="padding-left: 24px;margin-bottom: 2em;">
                    No Responses
                </p>

            </mat-card>

        </div>

        <h2 fxLayoutAlign="space-between">
            <span>Responses</span>
            <button mat-flat-button color="primary" (click)="downloadResponses()"><mat-icon>download</mat-icon> Download</button>
        </h2>

        <ng-container *ngFor="let questionId of moduleObj.questionsOrderedIDs; let i = index;">
            <ng-container *ngTemplateOutlet="questionPanel; context: { index: i, question: moduleObj.questions.get(questionId), id: questionId}">
            </ng-container>
        </ng-container>

    </div>

    <h2 *ngIf="moduleObj.questionsOrderedIDs.length == 0">
        No Questions
    </h2>

</div>

<ng-template #questionPanel let-question="question" let-id="id" let-i="index">

    <mat-expansion-panel [expanded]="true" style="margin-bottom: 2rem; padding: 0.5rem">

        <mat-expansion-panel-header style="margin-bottom: 1rem;">
            <mat-panel-title>
                <strong style="font-size: 1.3rem;">Question {{i + 1}} - {{question.value}}</strong>
            </mat-panel-title>
        </mat-expansion-panel-header>

        <mat-expansion-panel *ngIf="question.type == QuestionType.MULTIPLE_CHOICE || question.type == QuestionType.MULTIPLE_SELECT" style="margin-bottom: 1.5rem; " [expanded]="true">
            <mat-expansion-panel-header>
                <strong>Responses by Option</strong>
            </mat-expansion-panel-header>

            <mat-table [dataSource]="question.choicesOrdered">

                <ng-container matColumnDef="Option">
                    <mat-header-cell *matHeaderCellDef>Option</mat-header-cell>
                    <mat-cell *matCellDef="let choice">
                        {{choice.value}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Responses">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="question.type == QuestionType.MULTIPLE_CHOICE"># of Responses</span>
                        <span *ngIf="question.type == QuestionType.MULTIPLE_SELECT"># of Responses incl. Option</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let choice">
                        {{choice.responses.length}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Correct">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let choice" style="text-align: right;">
                        <div *ngIf="moduleObj.type == ModuleType.TEST">
                            <mat-icon *ngIf="choice.correct" color="accent" matTooltip="Correct">check_circle</mat-icon>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef>
                        <button mat-button>Details...</button>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="['Option',  'Responses', 'Correct']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['Option',  'Responses', 'Correct'];"></mat-row>

            </mat-table>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="question.type == QuestionType.MULTIPLE_CHOICE || question.type == QuestionType.MULTIPLE_SELECT" [expanded]="true">

            <mat-expansion-panel-header>
                <strong>Responses by User</strong>
            </mat-expansion-panel-header>

            <mat-table [dataSource]="question.userResponses | keyvalue">

                <ng-container matColumnDef="User">
                    <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
                    <mat-cell *matCellDef="let userResponses">
                        <p>
                            {{userResponses.value.name}}
                        </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Options">
                    <mat-header-cell *matHeaderCellDef>
                        <span *ngIf="question.type == QuestionType.MULTIPLE_CHOICE">Option</span>
                        <span *ngIf="question.type == QuestionType.MULTIPLE_SELECT">Options</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let userResponses;" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="0.5em" style="padding:0.5em">
                        <span *ngFor="let choice of userResponses.value.response.choices" style="white-space: pre-wrap;">{{choice.value}}</span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Correct">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let userResponses" style="text-align: right;">
                        <div *ngIf="moduleObj.type == ModuleType.TEST">
                            <mat-icon *ngIf="userResponses.value.response.correct" color="accent" matTooltip="Correct">check_circle</mat-icon>
                            <mat-icon *ngIf="!userResponses.value.response.correct" color="warn" matTooltip="Incorrect">cancel</mat-icon>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="['User', 'Options', 'Correct']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['User', 'Options', 'Correct']"></mat-row>

            </mat-table>

            <p *ngIf="question.userResponses.size == 0" style="padding-left: 24px;">
                No Responses
            </p>

        </mat-expansion-panel>

        <div *ngIf="question.type == QuestionType.SHORT_FORM || question.type == QuestionType.LONG_FORM">

            <mat-table [dataSource]="question.userResponses | keyvalue">

                <ng-container matColumnDef="User">
                    <mat-header-cell *matHeaderCellDef>User</mat-header-cell>
                    <mat-cell *matCellDef="let userResponses;">
                        <p>
                            {{userResponses.value.name}}
                        </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ResponseValue">
                    <mat-header-cell *matHeaderCellDef>Response</mat-header-cell>
                    <mat-cell *matCellDef="let userResponses;">
                        <p style="white-space: pre-wrap;">{{userResponses.value.response.value}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Correct">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let userResponses" style="text-align: right;">
                        <div *ngIf="moduleObj.type == ModuleType.TEST">
                            <button mat-button mat-icon-button *ngIf="userResponses.value.response.correct" (click)="markResponse(userResponses.value.response, id, userResponses.key, false)" [disabled]="userResponses.value.response.marking" matTooltip="Correct. Click to Mark Incorrect"
                                color="accent">
                            <mat-icon>check_circle</mat-icon>
                            </button>
                            <button mat-button mat-icon-button *ngIf="!userResponses.value.response.correct" (click)="markResponse(userResponses.value.response, id, userResponses.key, true)" [disabled]="userResponses.value.response.marking" matTooltip="Incorrect. Click to Mark Correct"
                                color="warn">
                            <mat-icon>cancel</mat-icon>
                        </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="['User', 'ResponseValue', 'Correct']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['User', 'ResponseValue', 'Correct']"></mat-row>

            </mat-table>
            <p *ngIf="question.userResponses.size == 0" style="padding-left: 24px;">
                No Responses
            </p>

        </div>

        <mat-expansion-panel *ngIf="question.type == QuestionType.LIKERT" style="margin-bottom: 1.5rem; " [expanded]="true">

            <mat-expansion-panel-header>
                <strong>Responses by User</strong>
            </mat-expansion-panel-header>

            <mat-table [dataSource]="question.userResponses | keyvalue">

                <ng-container matColumnDef="User">
                    <mat-header-cell *matHeaderCellDef fxFlex="15">User</mat-header-cell>
                    <mat-cell *matCellDef="let userResponses;" fxFlex="15">
                        <p>
                            {{userResponses.value.name}}
                        </p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ResponseValue">
                    <mat-header-cell *matHeaderCellDef fxFlex>Response</mat-header-cell>
                    <mat-cell *matCellDef="let userResponse;" fxLayout="column" fxLayoutAlign="center stretch" fxLayoutGap="1rem" style="padding:1rem" fxFlex>
                        <mat-radio-group [value]="userResponse.value.response.value[choiceIndex]" *ngFor="let choice of question.choicesOrdered; let choiceIndex = index" fxLayoutAlign="space-between end">
                            <div *ngIf="choice.value[0]" fxFlex="15"><strong>{{choice.value[0]}}</strong></div>
                            <div *ngIf="choice.value[1] || question.defaultMinLabel" fxFlex="10">{{choice.value[1] || question.defaultMinLabel}}</div>
                            <mat-radio-button class="likert" *ngFor="let option of question.scaleOptionArray" [value]="option" color="primary" disabled fxFlex>{{option + 1}}</mat-radio-button>
                            <div *ngIf="choice.value[2] || question.defaultMaxLabel" fxFlex="10">{{choice.value[2] || question.defaultMaxLabel}}</div>
                        </mat-radio-group>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Correct">
                    <mat-header-cell *matHeaderCellDef fxFlex="10"></mat-header-cell>
                    <mat-cell *matCellDef="let userResponses" fxFlex="10">
                        <div *ngIf="moduleObj.type == ModuleType.TEST">
                            <button mat-button mat-icon-button *ngIf="userResponses.value.response.correct" color="accent">
                            <mat-icon>check_circle</mat-icon>
                            </button>
                            <button mat-button mat-icon-button *ngIf="!userResponses.value.response.correct" color="warn">
                            <mat-icon>cancel</mat-icon>
                        </button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="['User', 'ResponseValue']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['User', 'ResponseValue']"></mat-row>

            </mat-table>
            <p *ngIf="question.userResponses.size == 0" style="padding-left: 24px;">
                No Responses
            </p>

        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="question.type == QuestionType.LIKERT" [expanded]="true">

            <mat-expansion-panel-header>
                <strong>Responses by Scale</strong>
            </mat-expansion-panel-header>

            <mat-table [dataSource]="question.choicesOrdered">

                <ng-container matColumnDef="ScaleLabel">
                    <mat-header-cell *matHeaderCellDef>Scale </mat-header-cell>
                    <mat-cell *matCellDef="let choice;">
                        <strong>{{choice.value[0]}}</strong>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="MinLabel">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let choice;">
                        {{choice.value[1] || question.defaultMinLabel}}
                    </mat-cell>
                </ng-container>

                <ng-container *ngFor="let c of question.scaleOptionArray" [matColumnDef]="'col' + c">
                    <mat-header-cell *matHeaderCellDef>{{c + 1}}</mat-header-cell>
                    <mat-cell *matCellDef="let choice;">
                        {{choice.responses[c]}}
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="MaxLabel">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let choice;">
                        {{choice.value[2] || question.defaultMaxLabel}}
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="question['cols']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: question['cols']"></mat-row>

            </mat-table>

        </mat-expansion-panel>

    </mat-expansion-panel>

</ng-template>